import dayjs from "dayjs";
import React from "react";
import { Trans } from "react-i18next";

import {
  OnboardingStatus,
  ProjectLocationWithProject,
} from "../../../models/ProjectData";

import "./styles.scss";

interface IOnboardingBannerProps {
  projectLocationData: ProjectLocationWithProject;
}

export const OnboardingBanner: React.FC<IOnboardingBannerProps> = ({
  projectLocationData,
}) => {
  const status: OnboardingStatus =
    projectLocationData.onboarding_status || "INCOMPLETE";
  const project = projectLocationData.project;
  const organizationName = project.organization?.name || "";

  return (
    <div className="white-border-panel padding32 onboarding-banner">
      <div className="banner-title">{organizationName}</div>
      <div className="banner-description">
        {status === "INCOMPLETE" && project?.onboarding_link && (
          <Trans
            i18nKey="facilityDetailsPage.onboardingBanner.incomplete_message"
            values={{ organization: organizationName }}
            components={{
              p: (
                <a
                  href={project.onboarding_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="banner-link"
                >
                  {project.onboarding_link}
                </a>
              ),
            }}
          />
        )}
        {status === "SCHEDULED" &&
          projectLocationData.onboarding_scheduled_date && (
            <Trans
              i18nKey="facilityDetailsPage.onboardingBanner.scheduled_message"
              values={{
                organization: organizationName,
                date: dayjs(
                  projectLocationData.onboarding_scheduled_date
                ).format("YYYY/MM/DD"),
              }}
            />
          )}
      </div>
    </div>
  );
};
